export default "__VITE_ASSET__DIyapJvq__"